import Cookies from 'js-cookie'
import i18n from '@/i18n'

const state = {
  language: Cookies.get('language') ? Cookies.get('language') : 'en-US'
}

const mutations = {
  SET_LANGUAGE: (state, language) => {
    state.language = language
    Cookies.set('language', language)
    i18n.locale = language
  }
}

const actions = {
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
